import CollapsibleSection from '@zocdoc/components/src/CollapsibleSection';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { LOCALIZED_STRINGS } from './constants';
import { FontFamily } from '@zocdoc/components/src/typography';

export default class InsuranceList extends React.PureComponent {
    static propTypes = {
        insurances: PropTypes.arrayOf(PropTypes.object).isRequired,
    }

    render() {
        const { insurances, ...props } = this.props;

        return (
            <div {...props}>
                {insurances.map(carrier => (
                    <CollapsibleSection
                        key={carrier.id}
                        headerText={carrier.name}
                    >
                        <ul>
                            {carrier.plans.map(plan => (
                                <StyledListItem key={plan.id}>
                                    {plan.name} {this.maybeRenderAcceptanceLimitations(plan)}
                                </StyledListItem>
                            ))}
                        </ul>
                    </CollapsibleSection>
                ))}
            </div>
        );
    }

    maybeRenderAcceptanceLimitations(plan) {
        const limitations = [];
        if (plan.locations && plan.locations.length > 0) {
            const locations = plan.locations
                .filter(location => location !== undefined)
                .map(location => location.address1).join(', ');
            limitations.push(
                <FormattedMessage
                    {...LOCALIZED_STRINGS.LocationLimitation}
                    values={{ locations }}
                />
            );
        }

        if (plan.providers && plan.providers.length > 0) {
            const providers = plan.providers.map(provider => provider.approvedFullName).join(', ');
            limitations.push(
                <FormattedMessage
                    {...LOCALIZED_STRINGS.ProviderLimitation}
                    values={{ providers }}
                />
            );
        }

        if (limitations.length) {
            return (
                <LimitationList>
                    {limitations.map((limitation, idx) => <StyledListItem key={idx}>{limitation}</StyledListItem>)}
                </LimitationList>
            );
        }
    }
}

const LimitationList = styled.ul`
    display: inline;
    list-style-type: 'none';
    font-style: italic;

    &:before {
        content: '(';
    }

    &:after {
        content: ')';
    }

    > li {
        display: inline;
    }
`;

const StyledListItem = styled.li`
    font: 16px/24px ${FontFamily.KievitSlabBook};
`;
